import HomeController from './home-view.controller';

require('./home-view.scss');

const HomeComponent = {
    selector: 'sbHome',
    controller: HomeController,
    template: require('./home-view.html'),
};

export default HomeComponent;



// WEBPACK FOOTER //
// ./src/app/home/home-view/index.js